module.exports = __webpack_public_path__ + "img/arh_4.87fb6163.png";